var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1114_2607)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1114_2607)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00821 18.012C9.00821 17.402 9.00656 16.792 9.00903 16.1829C9.01067 15.6179 9.28818 15.2171 9.81856 15.1096C10.1618 15.0404 10.1724 14.8704 10.2077 14.6021C10.6232 11.4364 12.794 8.92231 15.7054 8.21816C20.0683 7.16236 24.1989 10.0448 24.7966 14.5721C24.8352 14.8621 24.8516 15.0438 25.2137 15.1171C25.7186 15.2196 25.9929 15.6113 25.9953 16.1504C26.0011 17.3695 26.0019 18.5895 25.9953 19.8094C25.992 20.3678 25.7228 20.7661 25.1809 20.8769C24.864 20.9419 24.8048 21.1161 24.74 21.3794C24.3327 23.036 22.9575 24.1235 21.2695 24.1401C20.9985 24.1426 20.7268 24.1493 20.4558 24.1385C19.9164 24.1176 19.464 24.2093 18.9665 24.5468C18.0322 25.1809 16.9681 25.1226 15.9927 24.546C15.271 24.1193 15.2907 23.4193 15.9845 22.9485C16.8688 22.3485 18.4443 22.4327 19.2424 23.1218C19.3286 23.1968 19.4197 23.3352 19.5051 23.3318C20.5749 23.2935 21.6833 23.5785 22.6915 22.976C23.1718 22.6894 23.5421 22.2969 23.7876 21.7894C23.992 21.3661 24.1891 21.0652 23.506 20.7453C22.9354 20.4778 22.4247 19.8944 22.4887 19.0603C22.5372 18.4345 22.5273 17.8003 22.492 17.1729C22.4312 16.1121 22.9403 15.4563 23.8598 15.0721C24.2285 14.9179 24.0249 14.6313 23.9969 14.4288C23.6324 11.7589 21.533 9.49812 18.9139 8.92564C15.2653 8.12733 11.7258 10.5189 11.0279 14.2555C10.9499 14.6738 10.9081 14.9396 11.4532 15.2254C12.0657 15.5471 12.7595 16.0571 12.6306 17.032C12.5592 17.5729 12.5337 18.1487 12.6363 18.6787C12.8227 19.642 12.2431 20.2044 11.6445 20.6769C11.0435 21.1511 10.2627 21.0419 9.58621 20.7836C9.00739 20.5628 8.98358 19.9828 9.00492 19.4278C9.02134 18.957 9.00739 18.4837 9.00821 18.012ZM23.6808 17.9945C23.6808 18.5053 23.7071 19.017 23.6735 19.5253C23.6406 20.0278 23.8467 20.2086 24.3171 20.1519C24.451 20.1361 24.5889 20.1386 24.7227 20.1519C25.0979 20.1894 25.2474 20.0194 25.2441 19.6428C25.2342 18.5437 25.2334 17.4437 25.2449 16.3446C25.249 15.9629 25.0922 15.8037 24.7227 15.8321C24.5495 15.8454 24.3738 15.8437 24.2006 15.8321C23.8336 15.8071 23.6669 15.9621 23.6776 16.3462C23.6932 16.8945 23.6817 17.4445 23.6808 17.9945ZM9.77341 18.0045C9.77341 18.5162 9.79393 19.0286 9.76766 19.5386C9.74385 19.9936 9.89985 20.2078 10.367 20.1486C10.5197 20.1294 10.6774 20.1353 10.8317 20.1478C11.1782 20.1753 11.3252 20.0236 11.3227 19.6695C11.3145 18.5478 11.3161 17.427 11.3227 16.3054C11.3243 15.9837 11.1921 15.8304 10.8711 15.8429C10.6774 15.8504 10.4828 15.8587 10.2898 15.8429C9.91709 15.8121 9.75781 15.9687 9.7693 16.3521C9.7849 16.902 9.77259 17.4537 9.77341 18.0045Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1114_2607",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1114_2607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1114_2607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1114_2607",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdesk);
export default __webpack_public_path__ + "static/media/helpdesk.aa24b2e7d5b4642aebb1562d5ff4b381.svg";
export { ForwardRef as ReactComponent };